import { render, staticRenderFns } from "./ModalWidget.vue?vue&type=template&id=3c8148d5&"
import script from "./ModalWidget.vue?vue&type=script&lang=js&"
export * from "./ModalWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports